import { isNil } from 'lodash-es'
import { useTranslations } from 'next-intl'

import { TSearchRoom } from '@/entities/map'
import { useFormatCurrency } from '@/shared/lib'

export type Props = Partial<Pick<TSearchRoom, 'usingFee' | 'mgmtFee'>>

export const PriceDetail = ({ usingFee, mgmtFee }: Props) => {
  const t = useTranslations('common')
  const { formatCurrency } = useFormatCurrency()

  if (isNil(usingFee) || isNil(mgmtFee)) return null

  return (
    <div className="typo-label1 flex gap-2 font-normal text-gray-500 not-last:mb-2">
      <p className="space-x-1">
        <span>{t('rent')}</span>
        <span className="text-gray-900">{formatCurrency(usingFee)}</span>
      </p>
      <p className="space-x-1">
        <span>{t('utility_fee')}</span>
        <span className="text-gray-900">{formatCurrency(mgmtFee)}</span>
      </p>
    </div>
  )
}
